var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20",
    on: {
      "click": _vm.calculate_progress,
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      }
    }
  }, [_c('h3', {
    staticClass: "mb-15 2xl:mb-20 w-full",
    attrs: {
      "id": "form-intitule"
    }
  }, [_vm._v("\n    Identification du titulaire\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.prenom == null ? _vm.infosPass.firstname : _vm.form.prenom,
      "libelle": "Prénom",
      "name": "prenom",
      "error": _vm.form.prenom.length === 0,
      "msg-error": ((_vm.errors || [])['data.prenom'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.form.prenom = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.nom == null ? _vm.infosPass.lastname : _vm.form.nom,
      "libelle": "Nom",
      "name": "nom",
      "error": _vm.form.nom.length === 0,
      "msg-error": ((_vm.errors || [])['data.nom'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.form.nom = newValue;
      }
    }
  }), _vm._v(" "), _c('date-picker', {
    staticClass: "col-span-full md:col-span-3",
    attrs: {
      "necessary-date": true,
      "value": _vm.form.date_naissance,
      "direction": "left",
      "format": "dd/MM/yyyy",
      "initialview": "year",
      "libelle": "Date de naissance",
      "name": "date_naissance"
    },
    on: {
      "input": function (newValue) {
        _vm.form.date_naissance = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "datas": [{
        value: 'Femme'
      }, {
        value: 'Homme'
      }, {
        value: 'Non-binaire'
      }],
      "necessary": true,
      "value": _vm.form.genre,
      "libelle": "Genre",
      "name": "genre"
    },
    on: {
      "input": function (newValue) {
        _vm.form.genre = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "datas": [{
        value: 'Célibataire'
      }, {
        value: 'Marié(e)'
      }, {
        value: 'Veuf(ve)'
      }, {
        value: 'Séparé(e)'
      }, {
        value: 'Divorcé(e)'
      }, {
        value: 'PACS'
      }, {
        value: 'Concubinage'
      }],
      "necessary": true,
      "value": _vm.form.situation,
      "libelle": "Situation familliale",
      "name": "situation"
    },
    on: {
      "input": function (newValue) {
        _vm.form.situation = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.telephone,
      "type": "tel",
      "error": true,
      "libelle": "Téléphone",
      "name": "telephone",
      "msg-error": ((_vm.errors || [])['data.telephone'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.form.telephone = newValue;
      },
      "focusInput": function ($event) {
        _vm.errors['data.telephone'] = [];
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.email,
      "libelle": "Email",
      "name": "email",
      "type": "email",
      "error": true,
      "msg-error": ((_vm.errors || [])['data.email'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.form.email = newValue;
      },
      "focusInput": function ($event) {
        _vm.errors['data.email'] = [];
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.website,
      "libelle": "Site internet personnel",
      "name": "website",
      "type": "text"
    },
    on: {
      "input": function (newValue) {
        _vm.form.website = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-6",
    attrs: {
      "necessary": true,
      "size": 5,
      "value": _vm.form.adresse,
      "libelle": "Adresse complète",
      "name": "adresse"
    },
    on: {
      "input": function (newValue) {
        _vm.form.adresse = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "datas": [{
        value: 'Structure Hébergement'
      }, {
        value: 'Appartement Collectif'
      }, {
        value: 'Famille'
      }, {
        value: 'Famille d\'accueil'
      }, {
        value: 'Logement personnel avec accompagnement (type SAVS)'
      }, {
        value: 'Logement personnel sans accompagnement'
      }, {
        value: 'Autres (hôpital, sans domicile...)'
      }],
      "necessary": true,
      "value": _vm.form.hebergement,
      "libelle": "Hébergement",
      "name": "hebergement"
    },
    on: {
      "input": function (newValue) {
        _vm.form.hebergement = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.hebergement === 'Autres (hôpital, sans domicile...)' ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.hebergement_precis,
      "libelle": "Autre hébergement",
      "name": "hebergement_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.hebergement_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-start-1 md:col-span-3",
    attrs: {
      "datas": [{
        value: 'Aucun'
      }, {
        value: 'Niveau 3 - CAP, BEP'
      }, {
        value: 'Niveau 4 - Baccalauréat'
      }, {
        value: 'Niveau 5 - DEUG, BTS, DUT, DEUST'
      }, {
        value: 'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1'
      }, {
        value: 'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur'
      }, {
        value: 'Niveau 8 - Doctorat, habilitation à diriger des recherches'
      }, {
        value: 'Autre'
      }],
      "necessary": true,
      "value": _vm.form.niveau,
      "libelle": "Niveau de formation",
      "name": "niveau"
    },
    on: {
      "input": function (newValue) {
        _vm.form.niveau = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.niveau === 'Autre' ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.niveau_precis,
      "libelle": "Autre niveau de formation",
      "name": "niveau_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.niveau_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": false,
      "value": _vm.form.dernier_diplome,
      "libelle": "Dernier diplôme obtenu",
      "name": "dernier_diplome"
    },
    on: {
      "input": function (newValue) {
        _vm.form.dernier_diplome = newValue;
      }
    }
  }), _vm._v(" "), _c('multiple-select', {
    staticClass: "lg:col-start-1 md:col-span-3",
    attrs: {
      "datas": [{
        value: 'Aucun'
      }, {
        value: 'Voiture'
      }, {
        value: 'Moto'
      }, {
        value: 'Scooter'
      }, {
        value: 'Vélo'
      }, {
        value: 'Marche'
      }, {
        value: 'Train'
      }, {
        value: 'Bus'
      }, {
        value: 'Transports en commun'
      }, {
        value: 'Autres'
      }],
      "necessary": true,
      "value": _vm.form.moyen_transport,
      "libelle": "Moyen de déplacement",
      "name": "moyen_transport"
    },
    on: {
      "input": function (newValue) {
        _vm.form.moyen_transport = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.moyen_transport.includes('Autres') ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.moyen_transport_precis,
      "libelle": "Autre moyen de transport",
      "name": "moyen_transport_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.moyen_transport_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('multiple-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "datas": [{
        value: 'ASSR1'
      }, {
        value: 'ASSR2'
      }, {
        value: 'BSR'
      }, {
        value: 'A'
      }, {
        value: 'A1'
      }, {
        value: 'B'
      }, {
        value: 'B1'
      }, {
        value: 'C'
      }, {
        value: 'D'
      }, {
        value: 'E'
      }, {
        value: 'Autres'
      }],
      "necessary": false,
      "value": _vm.form.permis,
      "libelle": "Permis de conduire",
      "name": "permis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.permis = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.permis.includes('Autres') ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": false,
      "value": _vm.form.permis_precis,
      "libelle": "Autre permis",
      "name": "permis_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.permis_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('multiple-select', {
    staticClass: "lg:col-start-1 md:col-span-3",
    attrs: {
      "datas": [{
        value: 'Aucun'
      }, {
        value: 'Salaire'
      }, {
        value: 'ARE'
      }, {
        value: 'AAH'
      }, {
        value: 'RSA'
      }, {
        value: 'ASS'
      }, {
        value: 'Pension invalidité'
      }, {
        value: 'Autres'
      }],
      "necessary": true,
      "value": _vm.form.type_revenus,
      "libelle": "Type de revenus",
      "name": "type_revenus"
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_revenus = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.type_revenus.includes('Autres') ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.type_revenus_precis,
      "libelle": "Autre type de revenus",
      "name": "type_revenus_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_revenus_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }],
      "necessary": true,
      "value": _vm.form.titre_sejour,
      "libelle": "Carte de séjour",
      "name": "titre_sejour"
    },
    on: {
      "input": function (newValue) {
        _vm.form.titre_sejour = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "my-16 xxl:my-20 2xl:my-22",
    attrs: {
      "id": "form-infos-generales"
    }
  }, [_vm._v("\n    Informations générales\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
  }, [_c('checkbox-indigo', {
    staticClass: "col-span-full md:col-span-6 place-self-start",
    attrs: {
      "is-checkbox-right": true,
      "value": _vm.form.travailleur_handicape,
      "libelle": "Etes-vous reconnu comme travailleur handicapé ?",
      "name": "travailleur_handicape"
    },
    on: {
      "input": function (newValue) {
        _vm.form.travailleur_handicape = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100"
    }
  }, [_vm.form.travailleur_handicape ? _c('div', {
    staticClass: "col-span-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
  }, [_c('div', {
    staticClass: "col-span-full md:col-span-6 flex"
  }, [_c('multiple-select', {
    attrs: {
      "datas": [{
        value: 'Handicap Intellectuel et difficultés de comportement'
      }, {
        value: 'Handicap psychique'
      }, {
        value: 'Handicap du Langage et de la Parole'
      }, {
        value: 'Handicap Auditif'
      }, {
        value: 'Handicap Visuel'
      }, {
        value: 'Handicap Viscéral et général'
      }, {
        value: 'Handicap Moteur et troubles associés'
      }, {
        value: 'Maladies invalidantes'
      }, {
        value: 'Trouble du spectre de l\'autisme (TSA)'
      }, {
        value: 'Autres handicaps'
      }, {
        value: 'Je ne souhaite pas le spécifier'
      }],
      "necessary": true,
      "value": _vm.form.handicap,
      "libelle": "Type de handicap",
      "name": "handicap"
    },
    on: {
      "input": function (newValue) {
        _vm.form.handicap = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-6 flex"
  }, [_c('input-select', {
    attrs: {
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }],
      "necessary": true,
      "value": _vm.form.lourdeur_handicap,
      "label-libelle": "Procédure qui a pour but de mesurer l'incidence du handicap sur la capacité de travail de la personne handicapée après un aménagement optimal de son poste de travail. La reconnaissance de la lourdeur du handicap permet de compenser l'effort réalisé par l'employeur pour l'adaptation du poste de travail, par l'attribution d'une minoration de la contribution due au titre de l'obligation d'emploi ou d'une aide a l'emploi. Depuis le 1er juillet 2011, c’est l'Association de gestion du fonds pour l'insertion professionnelle des personnes handicapées (AGEFIPH) qui gère ce dispositif d’attribution de la lourdeur du handicap (Loi de finances 2011).",
      "libelle": "Reconnaissance lourdeur de handicap",
      "name": "lourdeur_handicap"
    },
    on: {
      "input": function (newValue) {
        _vm.form.lourdeur_handicap = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-out duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.handicap.includes('Autres handicaps') ? _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "necessary": true,
      "value": _vm.form.handicap_precis,
      "libelle": "Autre handicap",
      "name": "handicap_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.handicap_precis = newValue;
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l(_vm.form.type_reconnaissance, function (type, i_t) {
    return _c('div', {
      key: i_t,
      staticClass: "transition-all duration-300 flex items-center justify-center my-10"
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
    }, [_c('div', {
      staticClass: "col-span-full md:col-span-6 flex space-x-4"
    }, [_c('delete-button', {
      staticClass: "pt-6 md:pt-7",
      on: {
        "del": function ($event) {
          return _vm.deleteItem(_vm.form.type_reconnaissance, i_t);
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "mr-4 flex-shrink flex-initial",
      attrs: {
        "datas": [{
          value: 'Aucune'
        }, {
          value: 'Reconnaissance travailleur handicapé délivrée par la CDAPH'
        }, {
          value: 'Titulaire d\'une rente d\'accident du travail ou d\'une maladie professionnelle'
        }, {
          value: 'Titulaire d\'une pension d\'invalidité'
        }, {
          value: 'Pensionné de guerre ou assimilé'
        }, {
          value: 'Titulaire de l\'allocation adulte handicapé'
        }, {
          value: 'Titulaire de la carte d\'invalidité'
        }, {
          value: 'Autre catégorie (Mutilé de guerre, assimilé mutilé de guerre, sapeur pompier volontaire)'
        }],
        "name": 'statut' + i_t,
        "necessary": true,
        "value": type.statut,
        "libelle": "Type de reconnaissance"
      },
      on: {
        "input": function (newValue) {
          type.statut = newValue;
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "hidden lg:flex col-start-auto col-span-6"
    }, [_c('input-text', {
      staticClass: "mr-4 flex-shrink flex-initial",
      attrs: {
        "name": 'cdaph' + i_t,
        "necessary": true,
        "value": type.cdaph,
        "label-libelle": "Les Commissions des Droits et de l’Autonomie des Personnes Handicapées (CDAPH) ont été créées par la loi n°2005-102 du 11 février 2005 pour 'l’égalité des droits et des chances, la participation et la citoyenneté des personnes handicapées'. Elles résultent de la fusion des Commissions techniques d’orientation et de reclassement professionnel (COTOREP) et des Commissions départementales d’éducation spéciale (CDES)",
        "libelle": "Numéro de dossier"
      },
      on: {
        "input": function (newValue) {
          type.cdaph = newValue;
        }
      }
    }), _vm._v(" "), _c('date-picker', {
      attrs: {
        "name": 'cdaph_validite' + i_t,
        "necessary-date": true,
        "value": type.cdaph_validite,
        "direction": "left",
        "format": "dd/MM/yyyy",
        "initialview": "year",
        "libelle": "Fin de validité"
      },
      on: {
        "input": function (newValue) {
          type.cdaph_validite = newValue;
        }
      }
    })], 1), _vm._v(" "), _c('input-text', {
      staticClass: "lg:hidden col-span-full",
      attrs: {
        "name": 'cdaph' + i_t,
        "necessary": true,
        "value": type.cdaph,
        "label-libelle": "Les Commissions des Droits et de l’Autonomie des Personnes Handicapées (CDAPH) ont été créées par la loi n°2005-102 du 11 février 2005 pour 'l’égalité des droits et des chances, la participation et la citoyenneté des personnes handicapées'. Elles résultent de la fusion des Commissions techniques d’orientation et de reclassement professionnel (COTOREP) et des Commissions départementales d’éducation spéciale (CDES)",
        "libelle": "Numéro de dossier"
      },
      on: {
        "input": function (newValue) {
          type.cdaph = newValue;
        }
      }
    }), _vm._v(" "), _c('date-picker', {
      staticClass: "lg:hidden col-span-full",
      attrs: {
        "name": 'cdaph_validite' + i_t,
        "necessary-date": true,
        "value": type.cdaph_validite,
        "direction": "left",
        "format": "dd/MM/yyyy",
        "initialview": "year",
        "libelle": "Fin de validité"
      },
      on: {
        "input": function (newValue) {
          type.cdaph_validite = newValue;
        }
      }
    })], 1)]);
  }), _vm._v(" "), _c('add-button', {
    staticClass: "my-10",
    attrs: {
      "libelle": "Ajouter un type de reconnaissance"
    },
    on: {
      "add": function ($event) {
        return _vm.addTypeReconnaissance();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('input-select', {
    staticClass: "lg:col-start-1 col-span-full md:col-span-6",
    attrs: {
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }],
      "necessary": true,
      "value": _vm.form.tutelle,
      "label-libelle": "<div class='block'>La Tutelle : <div><ul class='list-inside list-disc'><li>Pour les majeurs : Mesure judiciaire destinée à protéger une personne majeure et/ou tout ou partie de son patrimoine si elle n'est plus en état de veiller sur ses propres intérêts. Un tuteur la représente dans les actes de la vie civile. Le juge peut énumérer, à tout moment, les actes que la personne peut faire seule ou non, au cas par cas.</li><li>Pour les mineurs : Lorsque les titulaires de l'autorité parentale ne peuvent plus l'exercer, une tutelle est ouverte pour les enfants mineurs. Le juge constitue un conseil de famille qui nomme un tuteur et un subrogé tuteur.</li></ul>",
      "libelle": "Tutelle ou Curatelle",
      "name": "tutelle"
    },
    on: {
      "input": function (newValue) {
        _vm.form.tutelle = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100"
    }
  }, [_vm.form.tutelle === 'Oui' ? _c('div', {
    staticClass: "md:col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "datas": [{
        value: 'Tutelle'
      }, {
        value: 'Curatelle simple'
      }, {
        value: 'Curatelle renforcée'
      }, {
        value: 'Autre'
      }],
      "necessary": true,
      "value": _vm.form.tutelle_precis,
      "label-libelle": "<ul class='list-inside list-disc'><li><div class='inline-block font-medium'>La curatelle simple :</div>\n                              Mesure judiciaire destinée à protéger une personne majeure qui, sans être hors d'état d'agir elle-même, a besoin d'être conseillée ou contrôlée d'une manière continue dans les actes importants de la vie civile. La curatelle n'est prononcée que s'il est établi que la mesure de sauvegarde de justice serait une protection insuffisante pour la personne.</li>\n                              <li><div class='inline-block font-medium'>La curatelle renforcée :</div>\n                              Basée sur l'article 472 du code civil, elle renforce les pouvoirs du curateur. En plus des pouvoirs attribués dans le cadre de la curatelle simple au curateur, ce dernier percevra seul les revenus de la personne protégée et assurera lui-même à l'égard des tiers le règlement de ses dépenses. Cette formule se rapproche un peu plus du système de la tutelle, tout en demeurant plus souple.</li></ul>",
      "libelle": "Précisez",
      "name": "tutelle_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.tutelle_precis = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.tutelle_precis === 'Autre' ? _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.tutelle_autre,
      "libelle": "Autre",
      "name": "tutelle_autre"
    },
    on: {
      "input": function (newValue) {
        _vm.form.tutelle_autre = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.tutelle_personne,
      "libelle": "Personne ou organisme",
      "name": "tutelle_personne"
    },
    on: {
      "input": function (newValue) {
        _vm.form.tutelle_personne = newValue;
      }
    }
  })], 1) : _vm._e()])], 1)], 2) : _vm._e()]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-start-1 md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.organisme_prescripteur,
      "libelle": "Organisme prescripteur",
      "name": "organisme_prescripteur"
    },
    on: {
      "input": function (newValue) {
        _vm.form.organisme_prescripteur = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.nom_referent,
      "libelle": "Nom du référent",
      "name": "nom_referent"
    },
    on: {
      "input": function (newValue) {
        _vm.form.nom_referent = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.tel_referent,
      "type": "tel",
      "error": true,
      "libelle": "Tél",
      "name": "tel_referent"
    },
    on: {
      "input": function (newValue) {
        _vm.form.tel_referent = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.organisme_social,
      "label-libelle": "Organisme référent social ou socioprofessionnel (Cap Emploi, Pôle Emploi, SAVS...)",
      "libelle": "Organisme référent",
      "name": "organisme_social"
    },
    on: {
      "input": function (newValue) {
        _vm.form.organisme_social = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.nom_referent_social,
      "libelle": "Nom du référent",
      "name": "nom_referent_social"
    },
    on: {
      "input": function (newValue) {
        _vm.form.nom_referent_social = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.tel_referent_social,
      "type": "tel",
      "error": true,
      "libelle": "Tél",
      "name": "tel_referent_social"
    },
    on: {
      "input": function (newValue) {
        _vm.form.tel_referent_social = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-start-1 md:col-span-6 col-span-full",
    attrs: {
      "datas": [{
        value: 'Scolarisation'
      }, {
        value: 'Formation initiale'
      }, {
        value: 'Activité professionnelle'
      }, {
        value: 'En recherche d\'emploi'
      }, {
        value: 'Autre'
      }],
      "necessary": true,
      "value": _vm.form.situation_emploi,
      "libelle": "Situation actuelle par rapport à l'emploi",
      "name": "situation_emploi"
    },
    on: {
      "input": function (newValue) {
        _vm.form.situation_emploi = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.situation_emploi === 'Autre' ? _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "necessary": true,
      "value": _vm.form.situation_emploi_precis,
      "libelle": "Autre situation par rapport à l'emploi",
      "name": "situation_emploi_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.situation_emploi_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full flex items-end space-x-4"
  }, [_c('checkbox-indigo', {
    staticClass: "w-6/12",
    attrs: {
      "is-checkbox-right": true,
      "value": _vm.form.pole_emploi,
      "libelle": "Etes-vous inscrit à Pôle Emploi ?",
      "name": "pole_emploi"
    },
    on: {
      "input": function (newValue) {
        _vm.form.pole_emploi = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-6/12 md:w-3/12"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.pole_emploi ? _c('input-text', {
    attrs: {
      "necessary": true,
      "value": _vm.form.numero_pole_emploi,
      "libelle": "N° demandeur d'emploi",
      "name": "numero_pole_emploi"
    },
    on: {
      "input": function (newValue) {
        _vm.form.numero_pole_emploi = newValue;
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-start-1 md:col-span-4 col-span-full",
    attrs: {
      "necessary": true,
      "value": _vm.form.emploi,
      "libelle": "Emploi (ou projet professionnel)",
      "name": "emploi"
    },
    on: {
      "input": function (newValue) {
        _vm.form.emploi = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "necessary": true,
      "value": _vm.form.structure,
      "libelle": "Nom de la structure actuelle",
      "name": "structure"
    },
    on: {
      "input": function (newValue) {
        _vm.form.structure = newValue;
      }
    }
  }), _vm._v(" "), _c('date-picker', {
    staticClass: "col-span-full md:col-span-4",
    attrs: {
      "necessary-date": true,
      "value": _vm.form.date_structure,
      "direction": "left",
      "format": "dd/MM/yyyy",
      "initialview": "year",
      "libelle": "Date d'entrée dans la structure",
      "name": "date_structure",
      "width": "t23"
    },
    on: {
      "input": function (newValue) {
        _vm.form.date_structure = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    class: 'lg:col-start-1 ' + (_vm.form.situation_anterieure === 'Autre' ? 'md:col-span-3' : 'md:col-span-6'),
    attrs: {
      "datas": [{
        value: 'Demandeur d\'Emploi'
      }, {
        value: 'Scolarité classique ou Formation'
      }, {
        value: 'Institution ou Service Spécialisé (IME, SIPFP, IES, IEM...)'
      }, {
        value: 'Service d\'Accompagnement Social (SSAD, SESSAD, SAVS...)'
      }, {
        value: 'Etablissement et Service d\'Aide par le Travail (ESAT)'
      }, {
        value: 'Entreprise Adaptée (EA)'
      }, {
        value: 'Centre de Distribution de Travail à Domicile (CDTD)'
      }, {
        value: 'Entreprise d\'Insertion (EI)'
      }, {
        value: 'Entreprise de Travail Temporaire (ETT, ETTI)'
      }, {
        value: 'Milieu Ordinaire / Handicap'
      }, {
        value: 'Milieu Ordinaire / Inaptitude'
      }, {
        value: 'Institution Sanitaire (CHR, CHS, CRF...) / Hospitalisation'
      }, {
        value: 'Autre'
      }],
      "necessary": true,
      "value": _vm.form.situation_anterieure,
      "libelle": "Situation antérieure à l'entrée dans la structure",
      "name": "situation_anterieure"
    },
    on: {
      "input": function (newValue) {
        _vm.form.situation_anterieure = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.situation_anterieure === 'Autre' ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "necessary": true,
      "value": _vm.form.situation_anterieure_precis,
      "libelle": "Autre situation antérieure",
      "name": "situation_anterieure_precis"
    },
    on: {
      "input": function (newValue) {
        _vm.form.situation_anterieure_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "necessary": true,
      "value": _vm.form.referent,
      "libelle": "Référent (ou responsable hiérarchique)",
      "name": "referent"
    },
    on: {
      "input": function (newValue) {
        _vm.form.referent = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "col-span-full md:col-span-6 lg:col-start-1",
    attrs: {
      "necessary": true,
      "size": 5,
      "value": _vm.form.conditions1,
      "libelle": "Conditions de travail recherchées (préconisation)",
      "name": "conditions1"
    },
    on: {
      "input": function (newValue) {
        _vm.form.conditions1 = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "col-span-full md:col-span-6",
    attrs: {
      "necessary": true,
      "size": 5,
      "value": _vm.form.conditions2,
      "libelle": "Recommandations et propositions de mesures individuelles",
      "name": "conditions2"
    },
    on: {
      "input": function (newValue) {
        _vm.form.conditions2 = newValue;
      }
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm.form.proches.length > 0 ? _c('div', _vm._l(_vm.form.proches, function (proche, index) {
    return _c('div', {
      key: index,
      staticClass: "transition-all duration-300 flex flex-col space-y-10 mb-10"
    }, [_c('div', {
      staticClass: "grid grid-cols-10 gap-x-4 gap-y-10 w-full"
    }, [_c('div', {
      staticClass: "col-span-10 md:col-span-4 flex space-x-4"
    }, [_c('delete-button', {
      staticClass: "pt-6 lg:pt-7",
      on: {
        "del": function ($event) {
          return _vm.deleteItem(_vm.form.proches, index);
        }
      }
    }), _vm._v(" "), _c('input-text', {
      attrs: {
        "name": 'prenom_proche' + index,
        "necessary": true,
        "value": proche.prenom_proche,
        "libelle": "Prénom"
      },
      on: {
        "input": function (newValue) {
          proche.prenom_proche = newValue;
        }
      }
    })], 1), _vm._v(" "), _c('input-text', {
      staticClass: "md:col-span-3",
      attrs: {
        "name": 'nom_proche' + index,
        "necessary": true,
        "value": proche.nom_proche,
        "libelle": "Nom"
      },
      on: {
        "input": function (newValue) {
          proche.nom_proche = newValue;
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-full md:col-span-3 grid grid-cols-2 gap-x-4"
    }, [_c('input-select', {
      class: proche.relation_proche === 'Autre' ? 'md:col-span-1' : 'md:col-span-full',
      attrs: {
        "datas": [{
          value: 'Conjoint(e)'
        }, {
          value: 'Parent'
        }, {
          value: 'Famille'
        }, {
          value: 'Autre'
        }],
        "name": 'relation_proche' + index,
        "necessary": true,
        "value": proche.relation_proche,
        "libelle": "Relation",
        "width": "t30"
      },
      on: {
        "input": function (newValue) {
          proche.relation_proche = newValue;
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-in duration-300",
        "enter-class": "opacity-0",
        "leave-active-class": "ease-out duration-300",
        "leave-to-class": "opacity-0"
      }
    }, [proche.relation_proche === 'Autre' ? _c('input-text', {
      staticClass: "md:col-span-1",
      attrs: {
        "necessary": true,
        "value": proche.relation_proche_precis,
        "libelle": "Autre relation",
        "name": "relation_proche_precis"
      },
      on: {
        "input": function (newValue) {
          proche.relation_proche_precis = newValue;
        }
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('input-text-area', {
      staticClass: "md:col-span-4",
      attrs: {
        "name": 'adresse_proche' + index,
        "necessary": true,
        "size": 5,
        "value": proche.adresse_proche,
        "libelle": "Adresse complète"
      },
      on: {
        "input": function (newValue) {
          proche.adresse_proche = newValue;
        }
      }
    }), _vm._v(" "), _c('input-text', {
      staticClass: "md:col-span-3",
      attrs: {
        "name": 'telephone_proche' + index,
        "necessary": true,
        "value": proche.telephone_proche,
        "libelle": "Téléphone",
        "error": true,
        "type": "tel"
      },
      on: {
        "input": function (newValue) {
          proche.telephone_proche = newValue;
        }
      }
    }), _vm._v(" "), _c('input-text', {
      staticClass: "md:col-span-3",
      attrs: {
        "name": 'mail_proche' + index,
        "necessary": true,
        "value": proche.mail_proche,
        "libelle": "Mail",
        "type": "email",
        "width": "t25",
        "error": true
      },
      on: {
        "input": function (newValue) {
          proche.mail_proche = newValue;
        }
      }
    })], 1), _vm._v(" "), index < _vm.form.proches.length - 1 ? _c('div', {
      staticClass: "w-full border-b border-gray-600"
    }) : _vm._e()]);
  }), 0) : _vm._e(), _vm._v(" "), _c('add-button', {
    attrs: {
      "libelle": "Ajouter un contact"
    },
    on: {
      "add": function ($event) {
        return _vm.addProche();
      }
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h3', {
    staticClass: "my-16 xxl:my-20 2xl:my-22 w-full",
    attrs: {
      "id": "form-contacts"
    }
  }, [_vm._v("\n    Personnes à contacter "), _c('br'), _vm._v("en cas d'urgence\n  ")]);

}]

export { render, staticRenderFns }